import { render, staticRenderFns } from "./AccettazionePrestazioniListComponent.vue?vue&type=template&id=2b32fe38&scoped=true"
import script from "./AccettazionePrestazioniListComponent.vue?vue&type=script&lang=js"
export * from "./AccettazionePrestazioniListComponent.vue?vue&type=script&lang=js"
import style0 from "./AccettazionePrestazioniListComponent.vue?vue&type=style&index=0&id=2b32fe38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b32fe38",
  null
  
)

export default component.exports